export default {
  permissionMenuMap: {
    'dashboard': 'Dashboard',
    'admin': '后台管理',
    'admin:user': '用户管理',
    'admin:role': '角色管理',
    'admin:permission': '权限管理',
    'link': '链接管理',
    'link:dynamic': '动态链接',
    'link:stats': '访问统计'
  }
};



// WEBPACK FOOTER //
// ./src/constant.js